export default class SavedResource {
    constructor(
        id,
        cardLink,
        cardFeatureCard,
        cardImageUrl,
        pageImageUrl,
        partnerLogoUrl,
        cardOverflowImage,
        title,
        cardText,
        cardDownloadLink,
        cardWebsiteLink,
        cardType,
        cardTags,
        cardStage,
        cardGradeLevel,
        cardLearningMode
    ) {
        this.assetId = id;
        this.link = cardLink;
        this.featureCard = cardFeatureCard;
        this.imageUrl = cardImageUrl;
        this.pageImageUrl = pageImageUrl;
        this.partnerLogoUrl = partnerLogoUrl;
        this.overflowImage = cardOverflowImage;
        this.pageTitle = title;
        this.text = cardText;
        this.downloadUrl = cardDownloadLink;
        this.websiteUrl = cardWebsiteLink;
        this.type = cardType;
        this.tags = cardTags;
        this.stage = cardStage;
        this.gradeLevel = cardGradeLevel;
        this.learningMode = cardLearningMode;
    }
}
